export default "__VITE_ASSET__BMx6lgWj__"